<template>
    <div class="col-12 col-md-11 col-lg-12 col-xl-11 py-3">
        <b-card no-body class="border shadow-sm p-4 rounded-lg">
            <ValidationObserver ref="registerForm">
                <b-row>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="nationality_code" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('nationality')">
                                <country-selectbox
                                    valueType="code"
                                    :public="true"
                                    :validateError="errors[0]"
                                    v-model="form.nationality_code">
                                </country-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="national_id" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('tc_or_passport')">
                                <b-form-input size="sm" v-model="form.national_id"
                                              v-mask="'###########'"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              class="rounded"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="birth_date" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('birthdate')">
                                <select-date v-model="form.birth_date" :state="errors[0] ? false : (valid ? true : null)"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('name')">
                                <b-form-input size="sm" v-model="form.name"
                                              @input="form.name = $event.toLocaleUpperCase('tr')"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              class="rounded text-uppercase"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="surname" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('surname')">
                                <b-form-input size="sm" v-model="form.surname"
                                              @input="form.surname = $event.toLocaleUpperCase('tr')"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              class="rounded text-uppercase"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6" class="mt-2">
                        <ValidationProvider name="phone" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('telephone')">
                                <b-form-input size="sm" v-model="form.phone"
                                              v-mask="'(5##)-###-####'"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              class="rounded"></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col sm="12" md="6" lg="6" class="mt-2">
                         <ValidationProvider name="email" rules="required|email" v-slot="{valid, errors }">
                             <b-form-group :label="$t('email_address')">
                                 <b-form-input size="sm" v-model="form.email" class="rounded" :state="errors[0] ? false : (valid ? true : null)" ></b-form-input>
                                 <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                             </b-form-group>
                         </ValidationProvider>
                    </b-col>
                </b-row>
            </ValidationObserver>
            <b-row class="mt-4">
                <b-col class="d-flex flex-column justify-content-center align-items-center">
                    <b-button @click="sendPin" variant="primary" :disabled="loading" class="px-5 font-weight-bold shadow-sm">
                        <b-spinner small v-if="loading"></b-spinner>
                        <span v-else>{{ $t('pin_code') + ' ' + $t('send') }}</span>
                    </b-button>
                    <b-button variant="link" class="mt-3 text-secondary" @click="$emit('switch-to-login')">{{ $t('login') }}</b-button>
                </b-col>
            </b-row>
        </b-card>

        <div class="row mt-4 pt-3 border-top w-100 mx-0">
            <div class="col-12 text-muted small px-0 text-center" v-html="$t('urgent_inquiries_help_text')"></div>
        </div>

        <CommonModal ref="emailVerification" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="clear">
            <template v-slot:CommonModalTitle>
                <template>
                    {{ $t('email_verification').toLocaleUpperCase('tr') }}
                </template>
            </template>
            <template v-slot:CommonModalContent>
                <div class="mb-3">
                    <div class="alert alert-info py-2 d-flex  justify-content-between align-items-center">
                        <strong>{{ form.email }}</strong>
                    </div>
                    <div class="alert alert-info py-2 d-flex  justify-content-between align-items-center">
                        <strong>{{ $t('email_pin_code_message') }}</strong>
                    </div>
                    <ValidationObserver ref="formSmsVerify">
                        <ValidationProvider name="pin" rules="required" v-slot="{valid, errors}">
                            <sms-input v-model="pin"
                                       :timerFrom="timer"
                                       @timerExpired="timerExpired"
                            />
                        </ValidationProvider>
                    </ValidationObserver>
                    <div class="d-flex justify-content-end mt-2">
                        <ProcessingButton v-if="timer===0" :label="$t('resend_code')" :variant="'link'" :processing="loading" @click="handleResendPin"/>
                    </div>
                    <div>
                        <ProcessingButton v-if="timer>0" :disabled="pin==null"  :label="$t('verify')" :processing="loading" class="d-flex justify-content-center align-item-center w-100 mt-4" @click="verify"/>
                    </div>
                </div>
            </template>
        </CommonModal>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import CommonModal from "@/components/elements/CommonModal.vue";
import SmsInput from "@/components/elements/SmsInput.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import SpecialStudentApplicationRegisterServices from "@/services/SpecialStudentApplicationRegisterServices";

export default {
    name: "RegisterComponent",
    components: {
        ValidationObserver,
        ValidationProvider,
        CommonModal,
        SmsInput,
        ProcessingButton
    },
    data() {
        return {
            form: {
                national_id: null,
                birth_date: null,
                name: null,
                surname: null,
                phone: null,
                email: null,
                nationality_code:null,
            },
            pin: null,
            timer: 0,
            loading: false
        }
    },
    methods: {
        clear() {
            this.pin = null;
        },
        timerExpired() {
            this.timer = 0;
        },
        checkPayload(payload){
            if (this.form.national_id){
                delete payload.passport_number;
            }
            if (this.form.passport_number){
                delete payload.national_id;
            }
        },
        async sendPin() {
            const isValid = await this.$refs.registerForm.validate();
            if (!isValid) return;
            this.loading = true;
            let payload = {
                national_id: this.form.national_id,
                passport_number: this.form.passport_number,
                birthdate: this.form.birth_date,
                name: this.form.name,
                surname: this.form.surname,
                email: this.form.email,
                phone: this.form.phone ? this.form.phone.replace(/\D/g, '') : null,
                nationality_code: this.form.nationality_code
            };
            this.checkPayload(payload)
            SpecialStudentApplicationRegisterServices.startApplication(payload).then(async(response) => {
                this.$toast.success(this.$t('proccess_success'));
                 this.openVerificationModal()
            }).catch(e => {
                this.showErrors(e,this.$refs.registerForm)
            }).finally(()=>{
                this.stopLoading()
            });

        },
        openVerificationModal() {
            this.timer = 120;
            this.loading = false;
            this.$refs.emailVerification.$refs.commonModal.show();
        },
        stopLoading() {
            this.loading = false;
        },
        handleResendPin() {
            this.loading = true;
            let payload = {
                national_id: this.form.national_id,
                passport_number: this.form.passport_number,
                birthdate: this.form.birth_date,
                name: this.form.name,
                surname: this.form.surname,
                email: this.form.email,
                phone: this.form.phone ? this.form.phone.replace(/\D/g, '') : null,
                nationality_code: this.form.nationality_code
            };
            this.checkPayload(payload)
              SpecialStudentApplicationRegisterServices.startApplication(payload).then(response => {
               this.onResendSuccess()
            }).catch(e => {
                this.stopLoading()
                this.showErrors(e,null);
            });
        },
        onResendSuccess() {
            this.loading = false;
            this.timer = 120;
            this.$toast.success(this.$t('proccess_success'));
        },
        async verify() {
            const isValid = await this.$refs.formSmsVerify.validate();
            if (!isValid) return;
            this.loading = true;
            let payload = {
                national_id: this.form.national_id,
                passport_number: this.form.passport_number,
                pin: this.pin
            };
            this.checkPayload(payload)

            SpecialStudentApplicationRegisterServices.verifyApplication(payload).then(async (response) => {
                await this.$store.dispatch('SpecialStudentApplicationRegister/setLoginData',response.data.data)
                this.verificationSuccess()
                setTimeout(()=> {
                    this.$router.push('/special-student/application/form');
                },500)
            }).catch(e => {
                this.showErrors(e,this.$refs.formSmsVerify)
            }).finally(()=>{
                this.stopLoading()
            });
        },
        verificationSuccess() {
            this.loading = false;
            this.$refs.emailVerification.$refs.commonModal.hide();
        }
    }
}
</script>
